import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

// import homeImage from "../assets/heroimage1exp2.webp";

const Home = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "white",
      }}
    >
      <Container>
        <Stack
          minHeight="80vh"
          alignItems="center"
          direction={{ xs: "column", lg: "row" }}
          spacing={4}
        >
          <Stack
            spacing={4}
            // minHeight="45vh"
            alignItems={{ xs: "center", lg: "flex-start" }}
            sx={{ marginTop: { xs: "3rem", md: "0px" } }}
          >
            <Typography
              variant="h1"
              sx={{
                pt: 5,
                marginTop: { xs: "2rem !important", md: 0 },
                fontSize: { xs: "40px", md: "46px" },
                fontWeight: 700,
                color: "black",
                textAlign: { xs: "center", lg: "start" },
              }}
            >
              Unlock Your Certification Success with DirectCertify
            </Typography>

            <Typography
              sx={{
                fontWeight: "400",
                textAlign: { xs: "center", md: "left" },
                fontSize: { xs: "16px", md: "20px" },
                lineHeight: "26px",
                color: theme.palette.text.secondary,
              }}
            >
              Unlocking Your Potential, One Certification at a Time - Enhance
              Your Skills, Boost Your Credentials, and Achieve Personal and
              Professional Success
            </Typography>
            <Stack
              width="100%"
              direction="row"
              alignItems="center"
              justifyContent={{ xs: "center", lg: "flex-start" }}
              spacing={3}
            >
              <Button
                component="a"
                href="#intro"
                variant="contained"
                sx={{
                  fontSize: { xs: "14px", md: "18px" },
                  lineHeight: { xs: "18px", md: "22px" },
                  py: 1,
                  px: 3,
                  backgroundColor: "#27b1bb",
                }}
              >
                Learn More
              </Button>
            </Stack>
          </Stack>
          {/* <Stack width="100%" alignItems="center">
            <Box
              component="img"
              src={homeImage}
              alt="Main hero section"
              width={600}
              height={400}
              loading="eager"
              sx={{
                maxWidth: { xs: "300px", md: "100%" },
                height: "auto",
                objectFit: "contain",
                borderRadius: 2,
                aspectRatio: "600 / 400",
              }}
            />
          </Stack> */}
        </Stack>
      </Container>
    </Box>
  );
};
export default Home;
